module.exports = __webpack_public_path__ + "static/media/zysx.3fc94f36.png";